<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"

import { ICON } from "@/lib/icons"

const page = usePage()
const flash = computed(() => page.props.flash as { notice?: string; alert?: string })
</script>

<template>
  <UAlert v-if="flash?.notice" color="success" :icon="ICON.success" :title="flash.notice" />
  <UAlert v-if="flash?.alert" color="error" :icon="ICON.error" :title="flash.alert" />
</template>
